import styles from './PageHeaderBanner.scss';

import React from 'react';

import { getField } from 'src/utils/EntryUtil';

import { useBankPersonalization } from '../BankPersonalization/BankPersonalization';
import { useProgramPromotion } from '../ProgramPromotion/ProgramPromotion';
import { useSalesChannel } from '../SalesChannel/SalesChannel';
import { BannerImage } from './BannerImage/BannerImage';
import { BannerText } from './BannerText/BannerText';
import { BannerTitle } from './BannerTitle/BannerTitle';

export const PageHeaderBanner: React.FC<{ children?: never }> = () => {
  const { salesChannel } = useSalesChannel();
  const { bankPersonalization } = useBankPersonalization();
  const { programPromotion, isProgramPromoLoading } = useProgramPromotion();

  const brandingBanner = getField(salesChannel, 'brandingBanner');
  const promotion = getField(salesChannel, 'currentPromotion');
  const currentPromotion = programPromotion || promotion;

  if (!brandingBanner && !currentPromotion) return null;
  if (isProgramPromoLoading) return null;

  return (
    <div className={styles.partnerBanner}>
      <div className={styles.container}>
        <BannerImage className={styles.partnerLogoContainer} bannerInfo={bankPersonalization || brandingBanner} />
        <div>
          <BannerTitle
            className={styles.partnerBannerTitle}
            bannerInfo={bankPersonalization || brandingBanner}
            currentPromotion={currentPromotion}
          />
          <BannerText
            brandingBanner={brandingBanner}
            currentPromotion={currentPromotion}
          />
        </div>
      </div>
    </div>
  );
};
